export const getCurrDatetime = (): string => {
  return new Date().toISOString();
};
